export default class PrettySequenceHelper {
  /**
   * Format section sequence hierarchy as a string
   * @param seqArray Array of numbers ([1,1,2])
   * @returns String (1.1.2)
   */
   static formatSequence(seqArray : number[]) : string {
    let prettySequence = '';
    seqArray.forEach(seq => {
      if (prettySequence.length > 0)
        prettySequence += '.';
      prettySequence += seq;
    });    
    return prettySequence;
  }    
}
